import React, { useState, useRef, KeyboardEvent, useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import './Login.css'
import * as tokenService from '../../services/token'
import * as actions from '../store/actions'
import { AppContext } from '../..'
import { useHistory } from 'react-router-dom'
import { RequestState } from '../../../modules/types'

function Login() {
  const { state, execute } = useContext(AppContext)
  const history = useHistory()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const keepUserLoggedInRef = useRef(null)
  const { error, partners, requestState } = state.auth
  const { t } = useTranslation(['auth','global'])

  async function login(username: string, password: string, keepUserLoggedIn: boolean) {
    await execute(actions.login(username, password, keepUserLoggedIn))
  }

  function removeUserData() {
    execute(actions.removeUserData())
  }

  async function postLogin() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const keepUserLoggedInCurrent = keepUserLoggedInRef.current as any
    const keepUserLoggedIn = keepUserLoggedInCurrent
      ? keepUserLoggedInCurrent.checked
      : false

    await login(username, password, keepUserLoggedIn)
  }

  function onReturnPress(e: KeyboardEvent) {
    const enterKeyCode = 13
    if (e.nativeEvent.keyCode === enterKeyCode) {
      postLogin()
    }
  }

  useEffect(() => {
    removeUserData()
  },
    // eslint-disable-next-line
    [])

  useEffect(() => {
    const authToken = tokenService.loadToken()

    if (authToken && partners && partners.length > 0) {
      history.push(`/partner/${partners[0].id}`)
    }
  },
    // eslint-disable-next-line
    [partners])

  return (
    <div id="login-page">
      <div id="login-panel">
          <img id="papertrail-logo" src="/pt.svg" alt="logo" />
          <input
            id="username"
            type="email"
            placeholder={t('email')}
            onKeyPress={onReturnPress}
            onChange={e => {
              setUsername(e.target.value)
            }}
          />

          <input
            id="password"
            type="password"
            placeholder={t('password')}
            onKeyPress={onReturnPress}
            onChange={e => {
              setPassword(e.target.value)
            }}
          />

          <div>
            <input ref={keepUserLoggedInRef} type="checkbox" id="keep-me-logged" name="scales" />
            <label htmlFor="keep-me-logged">{t('keep_me_logged')}</label>
          </div>

          <button disabled={requestState === RequestState.Loading} id="btn-login" onClick={postLogin}>
            {requestState === RequestState.Loading ? t('global:please_wait') : t('sign_in')}
          </button>

          {requestState === RequestState.Error && error === "invalid_usertype" && (
            <p id="invalid-credentials">
              { t('invalid_usertype') }
            </p>
          )}

          {requestState === RequestState.Error && error === "login_error" && (
            <p id="invalid-credentials">
              { t('invalid_credentials') }
            </p>
          )}
      </div>
    </div>
  )
}

export default Login
